import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as constants from '../../constants-types/constants';
import { Util } from '../../core-utilities';
import { TranslationService } from '../../translations';
import { PagerUtilities } from '../Pager.utility';
@Component({
    selector: 'list-pager',
    template: `
        @if (util.hasValue(dataList.length)) {
            <div class="pi-pagination">
                <div
                    data-testing="pagingAndTotalCountInformation"
                    class="pi-pagination_resultSizeInformation"
                >
                    {{ resultSizeInformation() }}
                </div>
                <div>
                    <span
                        class="pi-pagination_pageNumber"
                        [ngClass]="{
                            'pi-pagination_pageNumber--clickableNumber':
                                1 < currentPage
                        }"
                        (click)="goToPage(currentPage - 1)"
                    >
                        {{ TR.key('text.common-terms.prev') }}
                    </span>
                    @for (
                        pageNumber of pagerUtil.pagingNumbersDisplay(
                            currentPage,
                            getMaxPages
                        );
                        track pageNumber
                    ) {
                        <span
                            class="pi-pagination_pageNumber"
                            [ngClass]="{
                                'pi-pagination_pageNumber--clickableNumber':
                                    isClickablePage(pageNumber),
                                'pi-pagination_pageNumber--currentPage':
                                    isCurrentPage(pageNumber)
                            }"
                            (click)="goToPage(pageNumber)"
                        >
                            @if (pageNumber === ellipsisValue) {
                                <span>...</span>
                            } @else {
                                {{ pageNumber }}
                            }
                        </span>
                    }
                    <span
                        class="pi-pagination_pageNumber"
                        [ngClass]="{
                            'pi-pagination_pageNumber--clickableNumber':
                                dataList.length / resultsPerPage > currentPage
                        }"
                        (click)="goToPage(currentPage + 1)"
                    >
                        {{ TR.key('text.common-terms.next') }}
                    </span>
                </div>
                <list-pager-size-picker
                    [resultsPerPage]="resultsPerPage"
                    (resultsSizeChange)="updateResultsPerPage($event)"
                >
                </list-pager-size-picker>
            </div>
        }
    `,
    standalone: false
})
export class ListPagerComponent {
    @Input()
    dataList: any[] = [];

    @Input()
    resultsPerPage = constants.tableDefaultResultsPerPage;

    @Output()
    selectedRangeChanged = new EventEmitter<{ start: number; end: number }>();

    currentPage = 1;

    resultsPerPageOptions = [
        constants.tableDefaultResultsPerPage,
        constants.serverApiMaxResults
    ];

    // To display the "..."
    ellipsisValue = -1;

    constructor(
        public TR: TranslationService,
        public util: Util,
        public pagerUtil: PagerUtilities
    ) {}

    get getMaxPages() {
        return Math.ceil(this.dataList.length / this.resultsPerPage);
    }

    isClickablePage(pageNumber: number): boolean {
        return (
            pageNumber !== this.currentPage && pageNumber !== this.ellipsisValue
        );
    }

    isCurrentPage(pageNumber: number): boolean {
        return pageNumber === this.currentPage;
    }

    resultSizeInformation() {
        if (this.dataList.length === 0) {
            return this.TR.key('tablePager.noResultsFound');
        }

        let currentResultRange = `${
            (this.currentPage - 1) * this.resultsPerPage + 1
        }-`;
        if (this.currentPage * this.resultsPerPage > this.dataList.length) {
            currentResultRange += this.dataList.length;
        } else {
            currentResultRange += `${this.currentPage * this.dataList.length}`;
        }

        return this.util.strings.formatString(
            this.TR.key('tablePager.resultSize'),
            currentResultRange,
            this.dataList.length
        );
    }

    updateResultsPerPage(resultsPerPage: number) {
        this.resultsPerPage = resultsPerPage;
        this.changeResultsRange(resultsPerPage);
    }

    goToPage(pageNumber: number) {
        // Don't bother
        if (
            pageNumber === this.currentPage ||
            // Don't go past bounds
            pageNumber < 1 ||
            pageNumber > this.getMaxPages
        ) {
            return;
        }

        this.changeResultsRange(this.resultsPerPage, pageNumber);
    }

    changeResultsRange(resultsPerPage: number, pageNumber = 1) {
        const max = resultsPerPage * pageNumber;
        const min = max - resultsPerPage;
        this.selectedRangeChanged.emit({ start: min, end: max });
    }
}
